import React, { useState } from "react";
import PdfTemplateCreator from "../../utils/PdfCreator/PdfTemplateCreator";
import { useTranslation } from "react-i18next";
import openBase64NewTab from "../../utils/PdfCreator/PdfCreator";
import whitePdfIcon from "../../assets/images/pdf-white-icon.png";
import { CmConstants } from "../../utils/constants/CmConstants";
import pdfBlackIcon from "../../assets/images/pdf-black-icon.png";
import { useSelector } from "react-redux";
import WhitePdfButtonProps from "./WhitePdfButtonProps";
import "./WhitePdfButton.scss";
import { downloadAdaMemberDocument, getAdaMemberDocumentsBySourceMenuID } from "../../services/ADAService";
import { format } from "date-fns";


const WhitePdfButton = (props: WhitePdfButtonProps) => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const { userId } = useSelector((state: any) => state.UserReducer);
  const { activeFund } = useSelector((state: any) => state.DashboardReducer);

  const handleClick = async () => {
    setLoading(true);
    if (props.PId) {
      const pdfData = await downloadAdaMemberDocument(
        sessionStorage.token.toUpperCase(),
        props.PId
      );
      pdfData.fileContent &&
        openBase64NewTab(
          pdfData.fileContent,
          pdfData.fileName.split(".")[1] == "DOCX"
        );
    } else if (props.masConfirmData) {
      await PdfTemplateCreator(props.masConfirmData);
    } else if (props.salaryDate) {
      const adaDocs = await getAdaMemberDocumentsBySourceMenuID(
        sessionStorage.token.toUpperCase(),
        Number.parseInt(sessionStorage.fundCode),
        format(new Date(props.salaryDate.slice(0, 4) + "-01-01").setMonth(- 4), "yyyy-MM-dd"),
        CmConstants.TlushiPension.SourceMenuId
      );
      if (adaDocs && adaDocs.length > 0) {
        const docNum = adaDocs.find(
          (item: any) => item.docDate === props.salaryDate
        )?.documentNum;
        if (docNum != null || docNum != undefined) {
          const pdfData = await downloadAdaMemberDocument(
            sessionStorage.token.toUpperCase(),
            docNum
          );
          pdfData.fileContent &&
            openBase64NewTab(
              pdfData.fileContent,
              pdfData.fileName.split(".")[1] == "DOCX"
            );
        }
      }
    }
    setLoading(false);
  };

  return (
      <button
        className="white-pdf-btn"
        onClick={handleClick}
        disabled={loading ? true : false}
      >
        {loading ? (
          <span className="white-pdf-text-mobile">{t("general.loading")}</span>
        ) : (
          <img className="mobile-icon-btn" src={pdfBlackIcon} alt="bPdf" />
        )}
        <img className="desktop-icon-btn" src={whitePdfIcon} alt="wPdf" />
        <span className="white-pdf-text">
          {loading ? t("general.loading") : t("general.watch")}
        </span>
      </button>
  );
};

export default WhitePdfButton;
